﻿import {JSX} from "react";

export interface WizardStepProps {
	title: string;
	/** Stable id for {@link WizardProps.startAt} - unlike `title` it is not translated and unlike a
	 *  position it does not move when a sibling step is hidden. */
	name?: string;
	hidden?: boolean;
	children: (props: WizardStepProps) => React.ReactNode;
}

export default function WizardStep(props: WizardStepProps): JSX.Element {
	return <>{props.children}</>;
}
